import { render } from "./Ressources.vue?vue&type=template&id=2f1f834b&scoped=true"
import script from "./Ressources.vue?vue&type=script&lang=js"
export * from "./Ressources.vue?vue&type=script&lang=js"

import "./Ressources.vue?vue&type=style&index=0&id=2f1f834b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2f1f834b"

export default script